import { Fragment, useEffect, useRef, useState } from 'react';

import { Accordion, AccordionTab } from 'primereact/accordion';
import { InputSwitch } from 'primereact/inputswitch';
import { Slider } from 'primereact/slider';
import { RadioButton } from 'primereact/radiobutton';

import { AssetService } from '../../../../service/AssetService';

import DraggablePosition from '../../../components/DraggablePosition';
import { ToastService } from '../../../../AppToast';
import { useTranslation } from '../../../../shared/language';

const dimensions = {
  A4: { width: 787, height: 1081 },
  A5: { width: 559, height: 787 }
};

export const Menu2 = (props) => {

  const { t } = useTranslation();

  const { attribute, changeAttribute, dispatchEvent } = props;

  const [activeIndex, setActiveIndex] = useState(null);

  const inputLogo = useRef(null);
  const inputBorder = useRef(null);


  const [suDungHinhNenFrom, setSuDungHinhNenFrom] = useState('pc');
  const inputBackground = useRef(null);
  const [backgrounds, setBackgrounds] = useState([]);
  const [backgroundOpacity, setBackgroundOpacity] = useState(32);

  const [borders, setBorders] = useState([]);

  useEffect(() => {
    AssetService.getList({}).then(data => {
    });
    setBackgrounds([
      '/assets/demo/images/hinh-nen/hinh-1.png',
      '/assets/demo/images/hinh-nen/hinh-2.png',
      '/assets/demo/images/hinh-nen/hinh-3.png',
      '/assets/demo/images/hinh-nen/hinh-4.png',
      '/assets/demo/images/hinh-nen/hinh-5.png',
      '/assets/demo/images/hinh-nen/hinh-6.png'
    ]);
    setBorders([
      '/assets/demo/images/hinh-nen/vien-1.png',
      '/assets/demo/images/hinh-nen/vien-2.png',
      '/assets/demo/images/hinh-nen/vien-3.png',
      '/assets/demo/images/hinh-nen/vien-4.png',
      '/assets/demo/images/hinh-nen/vien-5.png',
      '/assets/demo/images/hinh-nen/vien-6.png',
      '/assets/demo/images/hinh-nen/vien-7.png',
      '/assets/demo/images/hinh-nen/vien-8.png',
      '/assets/demo/images/hinh-nen/vien-9.png',
      '/assets/demo/images/hinh-nen/vien-10.png',
      '/assets/demo/images/hinh-nen/vien-11.png',
      '/assets/demo/images/hinh-nen/vien-12.png',
    ]);
  }, []);

  const stopPropagation = (e) => {
    e.stopPropagation();
  }

  const checkActiveIndex = (from) => {
    if (activeIndex === from) {
      setActiveIndex(null);
    }
  }

  const onSuDungQrCodeChange = (value) => {
    changeAttribute('useBarcode', value);
    if (!value) {
      checkActiveIndex(0);
    }

    let event;
    if (value) {
      event = new CustomEvent('setCss', {
        detail: { selector: '#data', property: 'display', value: '' }
      });
    } else {
      event = new CustomEvent('setCss', {
        detail: { selector: '#data', property: 'display', value: 'none' }
      });
    }
    dispatchEvent(event);
  }
  const onQrCodeSizeChange = (value) => {
    changeAttribute('qrCodeSize', value);

    const event = new CustomEvent('setCss', {
      detail: { selector: '#data', property: 'width', value: `${value}px` }
    });
    dispatchEvent(event);
  }

  const onSuDungLogoChange = (value) => {
    changeAttribute('useLogo', value);
    if (!value) {
      checkActiveIndex(1);
    }

    let event;
    if (value) {
      event = new CustomEvent('setCss', {
        detail: { selector: '.logo-img', property: 'display', value: '' }
      });
    } else {
      event = new CustomEvent('setCss', {
        detail: { selector: '.logo-img', property: 'display', value: 'none' }
      });
    }
    dispatchEvent(event);
  }

  const onUploadLogo = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];

      if (!file) return;

      // Validate file size (100KB = 100 * 1024 bytes)
      if (file.size > 100 * 1024) {
        ToastService.error(t('common.logoFileSizeExceeded'));
        return;
      }

      // Validate file type
      if (!file.type.startsWith('image/')) {
        ToastService.error(t('common.imageFileRequired'));
        return;
      }

      // Validate image dimensions
      const img = new Image();
      img.onload = () => {
        const { width, height } = img;
        const maxWidth = 160;
        const maxHeight = 200;

        if (width > maxWidth || height > maxHeight) {
          ToastService.error(t('common.logoDimensionExceeded', { width: maxWidth, height: maxHeight }));
          return;
        }

        // If validation passes, proceed with upload
        const reader = new FileReader();
        reader.onloadend = () => {
          const event = new CustomEvent('setAttr', {
            detail: { selector: '.logo-img', property: 'src', value: reader.result }
          });
          dispatchEvent(event);
        };
        reader.readAsDataURL(file);
      };

      img.onerror = () => {
        ToastService.error(t('common.imageReadFailed'));
      };

      img.src = URL.createObjectURL(file);
    }
  }

  const onUploadBorder = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    if (file.size > 300 * 1024) {
      ToastService.error(t('common.borderFileSizeExceeded'))
      return;
    }

    const { width: maxWidth, height: maxHeight } = dimensions[attribute.pageSize] || {};

    const img = new Image();
    img.onload = () => {
      const { width, height } = img;

      if (!maxWidth || !maxHeight) {
        ToastService.error(t('common.borderDimensionExceeded', { pageSize: attribute.pageSize, width: dimensions[attribute.pageSize].width, height: dimensions[attribute.pageSize].height }))
        return;
      }

      if (width > maxWidth || height > maxHeight) {
        ToastService.error(t('common.borderDimensionExceeded', { pageSize: attribute.pageSize, width: dimensions[attribute.pageSize].width, height: dimensions[attribute.pageSize].height }))
        return;
      }

      setBorders((prevBorders) => [...prevBorders, file]);
    };

    img.onerror = () => {
      ToastService.error()
    };

    img.src = URL.createObjectURL(file);
  };



  const onLogoSizeChange = (value) => {
    changeAttribute('logoSize', value);

    const event = new CustomEvent('setCss', {
      detail: { selector: '.logo-img', property: 'width', value: `${value}px` }
    });
    dispatchEvent(event);
  }

  const onSuDungHinhNenChange = (value) => {
    changeAttribute('useBackgroundLogo', value);
    if (!value) {
      checkActiveIndex(3);
    }

    let event;
    if (value) {
      event = new CustomEvent('setCss', {
        detail: { selector: '#vong3', property: 'display', value: '' }
      });
    } else {
      event = new CustomEvent('setCss', {
        detail: { selector: '#vong3', property: 'display', value: 'none' }
      });
    }
    dispatchEvent(event);
  }
  const setBackground = (value) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const event = new CustomEvent('setAttr', {
          detail: { selector: '#vong3', property: 'src', value: reader.result }
        });
        dispatchEvent(event);
      }
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', value);
    xhr.responseType = 'blob';
    xhr.send();
  }
  const onUploadBackground = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];

      if (!file) return;

      // Validate file size (200KB = 200 * 1024 bytes)
      if (file.size > 200 * 1024) {
        ToastService.error(t('common.backgroundFileSizeExceeded'));
        return;
      }

      // Validate file type
      if (!file.type.startsWith('image/')) {
        ToastService.error(t('common.imageFileRequired'));
        return;
      }

      // Validate image dimensions
      const img = new Image();
      img.onload = () => {
        const { width, height } = img;
        const maxWidth = 460;
        const maxHeight = 610;

        if (width > maxWidth || height > maxHeight) {
          ToastService.error(t('common.backgroundDimensionExceeded', { width: maxWidth, height: maxHeight }));
          return;
        }

        // If validation passes, proceed with upload
        const reader = new FileReader();
        reader.onloadend = () => {
          const event = new CustomEvent('setAttr', {
            detail: { selector: '#vong3', property: 'src', value: reader.result }
          });
          dispatchEvent(event);
        };
        reader.readAsDataURL(file);
      };

      img.onerror = () => {
        ToastService.error(t('common.imageReadFailed'));
      };

      img.src = URL.createObjectURL(file);
    }
  }
  const onBackgroundPositionChange = ({ top, left }) => {
    const value = `matrix(1, 0, 0, 1, ${(parseInt(left) - 63) * 4}, ${(parseInt(top)) * 5})`;
    const event = new CustomEvent('setCss', {
      detail: { selector: '#vong3', property: 'transform', value }
    });
    dispatchEvent(event);
  }
  const onBackgroundSizeChange = (value) => {
    changeAttribute('backgroundSize', value);

    const event = new CustomEvent('setCss', {
      detail: { selector: '#vong3', property: 'width', value: `${value}px` }
    });
    dispatchEvent(event);
  }
  const onBackgroundOpacityChange = (value) => {
    setBackgroundOpacity(value);

    const event = new CustomEvent('setCss', {
      detail: { selector: '#vong3', property: 'opacity', value: `${(value / 100)}` }
    });
    dispatchEvent(event);
  }

  const onSuDungKhungVienChange = (value) => {
    changeAttribute('useBordersBackground', value);
    if (!value) {
      checkActiveIndex(4);
    }

    let event;
    if (value) {
      event = new CustomEvent('setCss', {
        detail: { selector: '#vong4', property: 'display', value: '' }
      });
    } else {
      event = new CustomEvent('setCss', {
        detail: { selector: '#vong4', property: 'display', value: 'none' }
      });
    }
    dispatchEvent(event);
  }
  const setBorder = (value) => {
    const handleFile = (file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const event = new CustomEvent('setAttr', {
          detail: { selector: '#vong4', property: 'src', value: reader.result }
        });
        dispatchEvent(event);
      };
      reader.readAsDataURL(file);
    };

    if (typeof value === 'string') {
      const xhr = new XMLHttpRequest();
      xhr.onload = () => {
        handleFile(xhr.response);
      };
      xhr.open('GET', value);
      xhr.responseType = 'blob';
      xhr.send();
    } else if (value instanceof File) {
      handleFile(value);
    } else {
      console.error("Unsupported value type. Must be a string (URL) or File object.");
    }
  };

  return (
    <div className="grid">
      <div className="col-12">
        <Accordion activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>

          <AccordionTab header={<Fragment>
            <span>{t('common.useQrCode')}</span>
            <div className="accordion-tab-header-action" onClick={stopPropagation}>
              <InputSwitch checked={attribute.useBarcode} onChange={(e) => onSuDungQrCodeChange(e.value)} />
            </div>
          </Fragment>} disabled={!attribute.useBarcode}>
            <div className="p-fluid">
              <div className="field grid">
                <label className="col-12 mb-2 md:col-5 md:mb-0">{t('common.sizeCustomization')}</label>
                <div className="col-12 md:col-6 pt-2">
                  <Slider value={attribute.qrCodeSize} min={50} max={300} onChange={(e) => onQrCodeSizeChange(e.value)} />
                </div>
              </div>
            </div>
          </AccordionTab>

          <AccordionTab header={<Fragment>
            <span>{t('common.useLogo')}</span>
            <div className="accordion-tab-header-action" onClick={stopPropagation}>
              <InputSwitch checked={attribute.useLogo} onChange={(e) => onSuDungLogoChange(e.value)} />
            </div>
          </Fragment>} disabled={!attribute.useLogo}>

            <div className="grid" onClick={() => inputLogo.current.click()}>
              <div className="col-12">
                <div className="image-uploader">
                  <input ref={inputLogo} type="file" accept="image/*" style={{ display: 'none' }} onChange={onUploadLogo} />
                  <i className="pi pi-image" />
                  <p>{t('common.chooseLogoFromComputer')}</p>
                  <p>{t('common.maxDimension', { dimension: '160x200' })}</p>
                </div>
              </div>
            </div>

            <div className="p-fluid">
              <div className="field grid">
                <label className="col-12 mb-2 md:col-5 md:mb-0">{t('common.sizeCustomization')}</label>
                <div className="col-12 md:col-6 pt-2">
                  <Slider min={50} max={200} value={attribute.logoSize} onChange={(e) => onLogoSizeChange(e.value)} />
                </div>
              </div>
            </div>
          </AccordionTab>

          <AccordionTab header={<Fragment>
            <span>{t('common.useBackground')}</span>
            <div className="accordion-tab-header-action" onClick={stopPropagation}>
              <InputSwitch checked={attribute.useBackgroundLogo} onChange={(e) => onSuDungHinhNenChange(e.value)} />
            </div>
          </Fragment>} disabled={!attribute.useBackgroundLogo}>
            <div className="grid">
              <div className="col-12 md:col-6">
                <div className="field-radiobutton">
                  <RadioButton inputId="suDungHinhNenFrom1" name="suDungHinhNenFrom" value="pc" checked={suDungHinhNenFrom === 'pc'} onChange={e => setSuDungHinhNenFrom(e.value)} />
                  <label htmlFor="suDungHinhNenFrom1">{t('common.chooseImageFromComputer')}</label>
                </div>
              </div>
              <div className="col-12 md:col-6">
                <div className="field-radiobutton">
                  <RadioButton inputId="suDungHinhNenFrom2" name="suDungHinhNenFrom" value="sv" checked={suDungHinhNenFrom === 'sv'} onChange={e => setSuDungHinhNenFrom(e.value)} />
                  <label htmlFor="suDungHinhNenFrom2">{t('common.chooseBackgroundFromLibrary')}</label>
                </div>
              </div>
            </div>

            {suDungHinhNenFrom === 'pc' &&
              <div className="grid" onClick={() => inputBackground.current.click()}>
                <div className="col-12">
                  <div className="image-uploader">
                    <input ref={inputBackground} type="file" accept="image/*" style={{ display: 'none' }} onChange={onUploadBackground} />
                    <i className="pi pi-image" />
                    <p>{t('common.chooseBackgroundFromComputer')}</p>
                    <p>{t('common.maxDimension', { dimension: '460x610' })}</p>
                  </div>
                </div>
              </div>
            }
            {suDungHinhNenFrom === 'sv' &&
              <div className="grid">
                {
                  backgrounds.map((background, index) => {
                    return (
                      <div key={index} className="col-3" onClick={() => {
                        setBackground(background)
                      }}>
                        <div className="card p-0">
                          <img src={background} alt="" width="100%" />
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            }

            <div className="grid">
              <div className="col-12">
                <DraggablePosition onChange={onBackgroundPositionChange} capitalSize={attribute.backgroundSize / 4} />
              </div>
            </div>

            <div className="p-fluid mt-4">
              <div className="field grid">
                <label className="col-12 mb-2 md:col-5 md:mb-0">{t('common.sizeCustomization')}</label>
                <div className="col-12 md:col-6 pt-2">
                  <Slider min={50} max={1200} value={attribute.backgroundSize} onChange={(e) => onBackgroundSizeChange(e.value)} />
                </div>
              </div>
              <div className="field grid">
                <label className="col-12 mb-2 md:col-5 md:mb-0">{t('common.opacity')}</label>
                <div className="col-12 md:col-6 pt-2">
                  <Slider min={1} max={100} value={backgroundOpacity} onChange={(e) => onBackgroundOpacityChange(e.value)} />
                </div>
              </div>
            </div>
          </AccordionTab>

          <AccordionTab header={<Fragment>
            <span>{t('common.useBorder')}</span>
            <div className="accordion-tab-header-action" onClick={stopPropagation}>
              <InputSwitch checked={attribute.useBordersBackground} onChange={(e) => onSuDungKhungVienChange(e.value)} />
            </div>
          </Fragment>} disabled={!attribute.useBordersBackground}>
            <div className="grid">
              <div className="col-12" onClick={() => inputBorder.current.click()}>
                <div className="image-uploader">
                  <input ref={inputBorder} type="file" accept="image/*" style={{ display: 'none' }} onChange={onUploadBorder} />
                  <i className="pi pi-image" />
                  <p>{t('common.chooseBorderFromComputer')}</p>
                  <p>{t('common.maxPageDimension', { pageSize: attribute.pageSize, width: dimensions[attribute.pageSize].width, height: dimensions[attribute.pageSize].height })}</p>
                </div>
              </div>
              {
                borders.map((border, index) => {
                  return (
                    <div key={index} className="col-3" onClick={() => {
                      setBorder(border)
                    }}>
                      <div className="card p-0">
                        <img src={typeof border === 'string' ? border : URL.createObjectURL(border)} alt="" width="100%" />
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </AccordionTab>
        </Accordion>
      </div>
    </div>
  );
}
